import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';

const ScoreCard = ({ label, value, total }) => (
  <Col xs="12" sm="6" md="4" lg className="mb-2">
    <Card className="shadow-sm">
      <CardBody className="py-2 px-3">
        <div className="text-uppercase text-muted font-weight-bold" style={{ fontSize: '11px', letterSpacing: '.05em' }}>
          {label}
        </div>
        <div className="text-monospace font-weight-bold" style={{ fontSize: '22px', color: '#32325d' }}>
          {value} <small className="text-muted font-weight-normal" style={{ fontSize: '13px' }}>/ {total}</small>
        </div>
      </CardBody>
    </Card>
  </Col>
);

const Scoreboard = ({ mode, muscleScore, nerveScore }) => {
  if (mode === 'muscle') {
    return (
      <Row className="mb-3">
        <ScoreCard label="Nerve" value={muscleScore.nerve} total={muscleScore.nerveTotal} />
        <ScoreCard label="Root" value={muscleScore.root} total={muscleScore.rootTotal} />
        <ScoreCard label="Function (choice)" value={muscleScore.fn} total={muscleScore.fnTotal} />
      </Row>
    );
  }

  return (
    <Row className="mb-3">
      <ScoreCard label="Muscles recalled" value={nerveScore.musclesRecalled} total={nerveScore.musclesTotal} />
      <ScoreCard label="Nerves complete" value={nerveScore.nervesComplete} total={nerveScore.nervesTotal} />
    </Row>
  );
};

export default Scoreboard;
